import React from 'react';
export function SocialProofBar() {
  const stats = ['🔥 +500 PERSONAS YA LO ESTÁN USANDO', '📚 6 Tomos + 3 Bonos.', '⭐ 4.9/5 Resultados reales', '🇦🇷 En todo el país'];
  return <div className="bg-brand-accent py-6 px-4 relative z-20 shadow-md" data-id="element-156">
      <div className="max-w-6xl mx-auto" data-id="element-157">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-8 text-center" data-id="element-158">
          {stats.map((stat, index) => <div key={index} className="text-white font-poppins font-bold text-sm md:text-base tracking-wide" data-id="element-159">
              {stat}
            </div>)}
        </div>
      </div>
    </div>;
}